<span *ngIf="field.show" class="gridLabelContainer d-flex items-center" [class.fieldAttachmentContainer]="!readOnly">
    <ng-container *ngIf="!hideDisplayNameData">
        <span class="fieldAttachmentLabel requiredAttachment" *transloco="let translate">
            <div class="fieldAttachmentLabelText">
                <span [textContent]="field.displayName"></span>
            </div>
            <div class="fieldAttachmentRequiredText" [class.mat-error]="field.message.errors.length > 0 || field.message.warnings.length > 0" [class.mat-has-warning]="field.message.warnings.length > 0">
                <span class="material-symbols-outlined" *ngIf="field.message.errors.length > 0" [title]="field.message.errors?.[0]">
                    error
                </span>
                <span class="material-symbols-outlined" *ngIf="field.message.warnings.length > 0" [title]="field.message.warnings?.[0]">
                    warning
                </span>
                <span *ngIf="!(field.message.errors.length > 0 || field.message.warnings.length > 0) && (field.isMandatory || field.isBusinessKey)">*Required</span>
            </div>
        </span>
    </ng-container>
    <span class="fieldAttachmentIcon leading-[100%] align-middle" (click)="openGridModel()" *transloco="let translate">
        <mat-icon [title]="translate('Open Grid View')">grid_on</mat-icon>
    </span>
    <material-button *ngIf="!readOnly && field?.description?.length > 0" matSuffix buttonType="icon" prefixIcon="info" prefixIconType="material" color="default" size="small" [titleText]="field?.description"></material-button>
</span>
